/*
 * Author: Dw
 * File Created: Wednesday, 24-08-07 05:22 pm
 * Last Modified: Saturday, 24-09-14 02:40 pm, by Roger
 */

import styled from '@emotion/styled';
import { motion } from 'framer-motion';
const Button = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
`;
const Line = styled(motion.div)`
  width: 100%;
  height: 2px;
`;
const ToggleMenuButton: React.FC<{
  open: boolean;
  setOpen: (open: boolean) => void;
}> = ({
  open: isOpen,
  setOpen
}) => {
  const handleToggle = () => {
    setOpen(!isOpen);
  };
  return <Button onClick={handleToggle} data-sentry-element="Button" data-sentry-component="ToggleMenuButton" data-sentry-source-file="ToggleMenuButton.tsx">
      <Line animate={{
      rotate: isOpen ? 45 : 0,
      y: isOpen ? 7 : 0,
      backgroundColor: isOpen ? '#fff' : '#707A8A'
    }} transition={{
      duration: 0.3
    }} data-sentry-element="Line" data-sentry-source-file="ToggleMenuButton.tsx" />
      <Line animate={{
      opacity: isOpen ? 0 : 1,
      backgroundColor: '#707A8A'
    }} transition={{
      duration: 0.3
    }} data-sentry-element="Line" data-sentry-source-file="ToggleMenuButton.tsx" />
      <Line animate={{
      rotate: isOpen ? -45 : 0,
      y: isOpen ? -7 : 0,
      backgroundColor: isOpen ? '#fff' : '#707A8A'
    }} transition={{
      duration: 0.3
    }} data-sentry-element="Line" data-sentry-source-file="ToggleMenuButton.tsx" />
    </Button>;
};
export default ToggleMenuButton;